import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { ClassroomQuizSession } from '../../../../Domain/ClassroomQuiz';
import { useQuizContext } from '../../../../Context/QuizContext';
import { QUIZ_SUB_ROUTES } from '../../constant';

import OfficialExamResultView from './OfficialExamResult.view';

const OfficialExamResult = ({ onEndQuiz, onExitClassroom }) => {
  const { isLastSubsectionInCourse } = useQuizContext();

  const history = useHistory();
  const match = useRouteMatch();

  const { examId } = match.params;

  return (
    <ClassroomQuizSession>
      {({ examSessionId }) => {
        if (examSessionId) {
          const path = QUIZ_SUB_ROUTES.SESSION.getPath(examId, examSessionId);
          history.push(path);
        }

        return (
          <OfficialExamResultView
            onGoToNextSubsection={onEndQuiz}
            isLastSubsectionInCourse={isLastSubsectionInCourse}
            onExitClassroom={onExitClassroom}
            onGoToSubsectionLanding={() => {
              history.push(QUIZ_SUB_ROUTES.LANDING.getPath(examId));
            }}
          />
        );
      }}
    </ClassroomQuizSession>
  );
};

export default OfficialExamResult;
